import { apiClient } from '../../axios';
import { GetNetworkStatusPolicyResponse } from './types';

export const getNetworkStatusPolicyApi = () =>
  apiClient.get<GetNetworkStatusPolicyResponse>('/v1/network-status-policy');
